var CITY, STATE, COLOR, INSCRIPTION, source_blank_image, source_city_image, source_coordinates_image, source_image, map_style, apparel_style;

window.addEventListener("load", initializeCustomMaps);

function initializeCustomMaps() {
    registerQueryVars();
    initializeSourceImages();
}

function initializeSourceImages() {

    // Define product
    var JACE_P = JSON.parse($("script[data-section-type='static-product']").html());

    for (var i = 0; i < JACE_P.product.tags.length; i++) {
        if (JACE_P.product.tags[i].indexOf("City_") == 0)
            CITY = JACE_P.product.tags[i].split("City_")[1];

        if (JACE_P.product.tags[i].indexOf("State_") == 0)
            STATE = JACE_P.product.tags[i].split("State_")[1];

        if (JACE_P.product.tags[i].indexOf("Map_") == 0)
            map_style = JACE_P.product.tags[i].split("Map_")[1];

        if (JACE_P.product.tags[i].indexOf("Apparel_") == 0)
            apparel_style = JACE_P.product.tags[i].split("Apparel_")[1];
    }
    const city_text = (CITY + "_" + STATE).toLowerCase().replace(/ /g, "").replace(".", "").replace("'", "");

    const TOPO_BASE = map_style == "Topographic" ? "_topo" : '';
    const SRC_URL_BASE = 'https://s3.us-west-1.amazonaws.com/jace.design.www/tshirts/lines/';
    $("#source_blank").attr("src", SRC_URL_BASE + city_text + "_tshirt_blank" + TOPO_BASE + ".png");
    $("#source_coordinates").attr("src", SRC_URL_BASE + city_text + "_tshirt_coordinates" + TOPO_BASE + ".png");
    $("#source_city").attr("src", SRC_URL_BASE + city_text + "_tshirt_city" + TOPO_BASE + ".png");
    source_blank_image = document.getElementById("source_blank");
    source_coordinates_image = document.getElementById("source_coordinates");
    source_city_image = document.getElementById("source_city");
    source_city_image.onload = function () {
        console.log("Source images loaded");
        console.log("Ready to build T-Shirt");
        registerForm();
        setGlobals();
        updateImages();
        return;
    };
}

function registerQueryVars() {
    if (getQueryVariable("size")) {
        var size = getQueryVariable("size").toUpperCase();
        if (size == "XS" || size == "S" || size == "M" || size == "L" || size == "XL" || size == "2XL") {
            $(".options-selection__option-value-input[value='" + size + "']").click();
            $("#jace-tshirt-size-label").text(size);
            $("#jace-tshirt-size").attr("data-value", size).val(size);
            var print_url = "&size=" + size;
            $("#print-url").attr("data-value", print_url).attr("value", print_url);
        }
    }
}

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}

function setGlobals() {
    $("input:checked").each(function (i) {
        var v = $(this).val().toLowerCase().replace(/ /g, '');
        if (v == 'xs' || v == 's' || v == 'm' || v == 'l' || v == 'xl' || v == '2xl') {
            // no changes with size
        } else if (v == 'coordinates') {
            INSCRIPTION = "coordinates";
            source_image = source_coordinates_image;
        } else if (v == 'citystate') {
            INSCRIPTION = "city";
            source_image = source_city_image;
        } else if (v == 'blank') {
            INSCRIPTION = "blank";
            source_image = source_blank_image;
        } else {
            COLOR = v;
        }
    });
}

function registerForm() {
    $(".options-selection__option-value-input").change(function () {
        const v = $(this).val().toLowerCase();
        if (v == "xs" || v == "s" || v == "m" || v == "l" || v == "xl" || v == "2xl") {
            // Change size on custom properties
            $("#jace-tshirt-size-label").text($(this).val());
            $("#jace-tshirt-size").attr("data-value", $(this).val()).val($(this).val());
            var print_url = "&size=" + $(this).val();
            $("#print-url").attr("data-value", print_url).attr("value", print_url);
        }
        setGlobals();
        updateImages();
    });
}

function updateImages() {

    updateFlat();
    updateLifestyle1();
    updateLifestyle2();
    //updateGhost();
    updateSquare();

    var existCondition = setInterval(function () {
        if (document.getElementById('jace_tshirts_details_canvas')) {
            console.log("Exists!");
            clearInterval(existCondition);
            updateDetailsCanvas();
        } else console.log("Still checking");
    }, 250); // check every 250ms
}

function updateDetailsCanvas() {


    var canvas = document.getElementById('jace_tshirts_details_canvas'),
        ctx = canvas.getContext("2d"),
        width = 1600,
        height = 1067;

    if (apparel_style == "Tshirt") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_twomodels.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(.47, Math.tan(-1 * Math.PI / 60), 0, .47, 370, 120);
            ctx.drawImage(source_image, 492, 1018, 310, 324); // Woman
            ctx.resetTransform();
            ctx.setTransform(.45, -0.06, 0.06, .46, 425, 80); // Man
            ctx.drawImage(source_image, 1100, 920, 305, 319);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Longsleeve") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/longsleeve_' + COLOR + "_fall.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, 0, 1, 718, 430);
            ctx.drawImage(source_image, 0, 0, 200, 223);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Crewneck") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_' + COLOR + "_wall.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, 0, 1, 577, 480);
            ctx.drawImage(source_image, 0, 0, 210, 213);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Hoodie") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_' + COLOR + "_gate.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, -0, 1, 750, 450);
            ctx.drawImage(source_image, 0, 0, 160, 167);
            ctx.resetTransform();

            const overlay = new Image;
            overlay.setAttribute('crossorigin', 'anonymous');
            overlay.src = "https://cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_" + COLOR + "_gate.png";
            overlay.onload = function () {
                ctx.drawImage(overlay, 0, 0, width, height);
                thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            }

        };
    }
}

function updateLifestyle1() {

    var canvas = document.getElementById('jace_tshirts_man_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_man_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    if (apparel_style == "Tshirt") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_man.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.drawImage(source_image, 833, 848, 366, 373);
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Longsleeve") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/longsleeve_' + COLOR + "_shop.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, .01, -0.03, 1, 840, 842);
            ctx.drawImage(source_image, 0, 0, 350, 366);
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Crewneck") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_' + COLOR + "_chain.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, -0, 0, 1, 800, 840);
            ctx.drawImage(source_image, 0, 0, 340, 355);
            ctx.resetTransform();

            const overlay = new Image;
            overlay.setAttribute('crossorigin', 'anonymous');
            overlay.src = "https://cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_chain.png?v=1741908495";
            overlay.onload = function () {
                ctx.drawImage(overlay, 0, 0, width, height);
                thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            }

        };
    } else if (apparel_style == "Hoodie") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_' + COLOR + "_board.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, -0, 1, 890, 480);
            ctx.drawImage(source_image, 0, 0, 170, 177);
            ctx.resetTransform();

            const overlay = new Image;
            overlay.setAttribute('crossorigin', 'anonymous');
            overlay.src = "https://cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_" + COLOR + "_board.png";
            overlay.onload = function () {
                ctx.drawImage(overlay, 0, 0, width, height);
                thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            }

        };
    }

}

function updateLifestyle2() {

    var canvas = document.getElementById('jace_tshirts_woman_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_woman_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    if (apparel_style == "Tshirt") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_woman.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, Math.tan(Math.PI / 60), 0, 1, 0, 0);
            ctx.drawImage(source_image, 880, 838, 324, 338);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Longsleeve") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/longsleeve_' + COLOR + "_vest.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0.17, -0.17, 1, 987, 880);
            ctx.drawImage(source_image, 0, 0, 500, 523);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Crewneck") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_' + COLOR + "_smile.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0.14, -0.14, 1, 790, 840);
            ctx.drawImage(source_image, 0, 0, 340, 355);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Hoodie") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_' + COLOR + "_jeans.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, -0, 1, 860, 750);
            ctx.drawImage(source_image, 0, 0, 295, 308);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    }
}

function updateFlat() {
    const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/' + apparel_style.toLowerCase() + '_' + COLOR + "_flat.jpg";

    var canvas = document.getElementById('jace_tshirts_flat_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_flat_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    var bg_img = new Image;
    bg_img.setAttribute('crossorigin', 'anonymous');
    bg_img.src = T_URL;
    bg_img.onload = function () {
        ctx.drawImage(bg_img, 0, 0, width, height);
        ctx.drawImage(source_image, 752, 572, 494, 517);
        thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
    };
}

function updateGhost() {
    const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_ghost.jpg";

    var canvas = document.getElementById('jace_tshirts_ghost_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_ghost_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    var bg_img = new Image;
    bg_img.setAttribute('crossorigin', 'anonymous');
    bg_img.src = T_URL;
    bg_img.onload = function () {
        ctx.drawImage(bg_img, 0, 0, width, height);
        ctx.drawImage(source_image, 1113, 947, 350, 366);
        thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
    };
}

function updateSquare() {
    const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/' + apparel_style.toLowerCase() + '_' + COLOR + "_square.jpg";

    var canvas = document.getElementById('jace_tshirts_square_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_square_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    var bg_img = new Image;
    bg_img.setAttribute('crossorigin', 'anonymous');
    bg_img.src = T_URL;
    bg_img.onload = function () {
        ctx.drawImage(bg_img, 0, 0, width, height);
        ctx.drawImage(source_image, (width - source_image.width * 2) / 2, (height - source_image.height * 2) / 2, source_image.width * 2, source_image.height * 2);
        thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
    };
}
